import {commentMoodsDataLoader} from '../../../util/dataLoader';
import {ICommentMoodsAPIResponse} from './commentMoodsSlice';


export function getCommentMoods(filters) {
  return new Promise<ICommentMoodsAPIResponse>((resolve) => {
    commentMoodsDataLoader.get(filters).then((res: ICommentMoodsAPIResponse) => {
      resolve(res)
    })
  })
}